import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import * as Notification from '../../components/Common/notification'
import PropTypes from 'prop-types'
import TitleBar from '../Layout/titleBar'
import TextField from '@material-ui/core/TextField'
import { Row, Col } from 'react-flexbox-grid'
import Button from '@material-ui/core/Button'
import CurrencyFormat from 'react-currency-format'
import 'react-anything-sortable/sortable.css'
import './styles.css';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { EditorState } from 'draft-js';
import MenuItem from '@material-ui/core/MenuItem'
import DragAndDrop from '../Common/dragAndDrop'
import Checkbox from '@material-ui/core/Checkbox'
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state/index';
import IconButton from '@material-ui/core/IconButton'
import CircularProgress from '@material-ui/core/CircularProgress';
import MoreVertIcon from '@material-ui/icons/MoreVert'
import Paper from '@material-ui/core/Paper';
import Menu from '@material-ui/core/Menu';
import {stateToHTML} from 'draft-js-export-html';
import CropperModal from '../CropperModal'
import Chip from '@material-ui/core/Chip';
import { withStyles } from '@material-ui/core/styles';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline'

const styles = theme => ({
    root: {
      display: 'flex',
      justifyContent: 'center',
      flexWrap: 'wrap',
      listStyle: 'none',
      //padding: theme.spacing(0.5),
      margin: 0,
    },
    chip: {
      //margin: theme.spacing(0.5),
    },
  });

class ArticuloGenericoNuevo extends React.Component{
    renderButtons = () => {
		return (
			<div>
				
				<Button variant="contained" className="btnSecundario" onClick={this.props.handleOnCancel}>CANCELAR</Button>
				<Button variant="contained" className="btnPrincipal" onClick={this.props.handleOnSave}>GUARDAR</Button>

			</div>
		)
    }


    //Los drag son para arrastrar las imagenes y cambiar el orden

    dragStart(e) {
        this.dragged = e.currentTarget;
        e.dataTransfer.effectAllowed = 'move';
        e.dataTransfer.setData('text/html', this.dragged);
    }
    dragEnd(e) {
        // update state
        var from = Number(this.dragged.dataset.id);
        var to = Number(this.over);

        if (from !== to && to !== -1 && this.over !== undefined) {
            if (this.props.canSwap === false) { return; }
    
            e.target.parentElement.style.borderColor = "" //le saco los bordes
            e.target.parentElement.style.borderWidth = "1px"
    
            this.overaux.lastChild.lastElementChild.style.borderColor = "";
            this.overaux.lastChild.lastElementChild.style.borderWidth = "1px"
    
            this.props.handleOnChangeOrderArticuloImagenes(from - 1, to - 1) // ya que utilizaremos los indices del array de imagenes
    
        }
        else {
            Notification.showError('Error al arrastrar. Intente nuevamente.')
            e.target.parentElement.style.borderColor = "" //le saco los bordes
            e.target.parentElement.style.borderWidth = "1px"
        }
    }
    dragOver(e) {
        e.preventDefault();
    
        if (e.target.className === 'placeholder') return;
        if (e.target.parentElement.parentElement.parentElement.dataset.id) {
    
            this.over = e.target.parentElement.parentElement.parentElement.dataset.id;
            this.overaux = e.target.parentElement.parentElement.parentElement;
            
            e.target.parentElement.style.borderColor = "cyan"
            e.target.parentElement.style.borderWidth = "3px"
    
        }
    }
    
    
    constructor(props){
        super(props)
        
        this.state = {
            editorState: EditorState.createEmpty(), // Editor para la descripcion
            subrubroClear : true, // Para que al principio el subrubro no tenga indice.
            update: false
          };

        this.etiquetaInput = React.createRef();
    }

    onEditorStateChange = (editorState) => {
        
        let auxiliar = editorState.getCurrentContent()
        let html = stateToHTML(auxiliar)
        this.props.handleOnDescripcion(html)
        this.setState({
          editorState
        })
      }

      onEditorStateClear = () => {
          
        let editor =  EditorState.createEmpty()
        this.setState({
          editorState : editor
        })
        this.props.onChangeFalseEditorState()
      }
    
      handleOnChangePrecio = (e) => {
		if (Number.isNaN(e.floatValue)) {
			this.props.handleOnPrecio(e.value)
		}
		else { this.props.handleOnPrecio(e.floatValue) }
    }
    
    handleOnSubrubro = (e) => {
        this.setState({
            subrubroClear : false
        })
        this.props.handleOnSubrubro(e)
    }

    componentWillReceiveProps = (props) => {
        if (props.clearState && this.state.update === false){
            this.onEditorStateClear()
            this.setState({
                update : true
            })
        }
    }

    handleOnAddEtiqueta = () => {
        this.props.handleOnAddEtiqueta();
        let txt = this.etiquetaInput
        txt.current.focus();
    }

    render() {
        const { editorState } = this.state;

        const classes = this.props;

        return(
            <div className='articuloCreateEdit'>
                <TitleBar
						title={this.props.esEdicion ? 'Edición Artículo' : 'Nuevo Artículo'}
						type='createArticulo'
						showSearch={false}
						buttons={this.renderButtons()}
					/>

                <Row style={{ backgroundColor: 'white' }}>
                    <Col md={6}>
                        <TextField
                            id="subrubro"
                            select
                            required
                            error= {this.props.errorDescription.errorSubrubro !== undefined ? true: false}
                            helperText = {this.props.errorDescription.errorSubrubro !== undefined ? this.props.errorDescription.errorSubrubro : '' }
                            label="Subrubro"
                            value = {this.props.articulo.idSubrubro}
                            onChange={this.handleOnSubrubro}
                            style={{ width: '100%' }}
                            margin="normal">
                           
                            
                            {this.props.rubros.subrubros !== undefined ? this.props.rubros.subrubros.map((e) =>{ 
                                    return(e.idRubro.toString() === this.props.match.params.idRubro &&
                                        <MenuItem key={e.idSubrubro} value={e.idSubrubro} >
                                            {e.nombre}
                                        </MenuItem>
									)}): ''}            
                        </TextField>
                    </Col>

                    <Col md={6} >
                        <TextField
                            required
                            id="articulo"
                            label="Articulo"
                            error= {this.props.errorDescription.errorNombre !== undefined ? true: false}
                            helperText = {this.props.errorDescription.errorNombre !== undefined ? this.props.errorDescription.errorNombre : '' }                            
                            style={{ width: '100%' }}
                            value = {this.props.articulo.nombre}
                            margin="normal"
                            onChange = {this.props.handleOnNombre}
                        >
                        </TextField>    
                    </Col>

                    <Col md={6} >
                        <TextField
                            id="codigoInterno"
                            label="Codigo interno"
                            style={{ width: '100%' }}
                            margin="normal"
                            value = {this.props.articulo.codigoInterno}
                            onChange = {this.props.handleOnCodigoInterno}
                            >
                        </TextField>
                    </Col>

                    <Col md={6} >
                        <CurrencyFormat
                            required
                            className='currencyInput'
                            customInput={TextField}
                            label="Precio"
                            style={{ width: '100%', marginTop: '15px', textAlign: 'right' }}
                            decimalScale={2}
                            fixedDecimalScale={true}
                            allowNegative={false}
                            decimalSeparator=","
                            thousandSeparator="."
                            prefix={'$'}
                            error= {this.props.errorDescription.errorPrecio !== undefined ? true: false}
                            helperText = {this.props.errorDescription.errorPrecio !== undefined ? this.props.errorDescription.errorPrecio : '' }
                            value={this.props.articulo.precio}
                            onValueChange={this.handleOnChangePrecio} />
                    </Col>
                </Row>

                <Row style={{ backgroundColor: 'white' }}>

                    <Col md={6} style={{display: 'flex', alignItems: 'baseline'}}>
                            <TextField
                                id="etiqueta"
                                label="Etiqueta"
                                style={{ width: '100%' }}
                                margin="normal"
                                value={this.props.campoEtiqueta}
                                inputRef={this.etiquetaInput}
                                onChange={this.props.handleOnCampoEtiqueta}
                                onKeyPress={(e) => {
									if (e.key === 'Enter') {
                                        this.handleOnAddEtiqueta();
									}
								}}
                            >
                            </TextField>
                            <AddCircleOutlineIcon 
                                style={{cursor: 'pointer'}} 
                                onClick={this.handleOnAddEtiqueta}
                            />
                    </Col>

                    <Col md={6} >
                        <ul className='campoEtiquetas'>
                            {this.props.articulo && this.props.articulo.etiquetas && this.props.articulo.etiquetas.map((data,index) => {
                                return (
                                    <li key={index}>
                                        <Chip
                                            label={data.etiqueta}
                                            clickable
                                            color="primary"
                                            classes={{root: classes.chip}}
                                            className='etiqueta'
                                            onDelete={data.etiquetaManual === true ? () => this.props.handleDelete(data.etiqueta) : undefined}
                                        />
                                    </li>
                                );
                            })}
                        </ul>
                    </Col>
                    {/*<div class="clsEditor">
                        
                        </div>*/}
                </Row>

                <Row>
                    <div class="clsEditor">
                    <Editor
                        editorState={editorState}
                        toolbarClassName="toolbarClassName"
                        wrapperClassName="wrapperClassName"
                        editorClassName="editorClassName"
                        onEditorStateChange={this.onEditorStateChange}
                        toolbar = {{
                            options: ['inline', 'blockType', 'fontSize', 'fontFamily', 'list', 'textAlign', 'remove', 'history'],        
                        }}
                        placeholder =  'Descripción'
                        editorStyle = {{paddingLeft: '15px'}}
                        
                    />
                    </div>
                </Row>

                <Row>
                    <div style= {{marginTop: '20px', backgroundColor: 'white', width:'100%'}}>
                    <Col md={6} >
                    
                            <TextField
                                required
                                id="stock"
                                label="Stock disponible"
                                style={{ width: '100%' }}
                                margin="normal"
                                value = {this.props.articulo.stockGenerico}
                                onChange = {this.props.handleOnStock}
                            >
                            </TextField>    
                        </Col>
                        </div>
                </Row>

                
                    <DragAndDrop
                        data-id='-1'
                        accept='image/jpeg, image/png'
                        message='Arrastra las imágenes o'
                        handleOnDrop={this.props.handleOnDropFile}
                        multiple={true} />

                <Paper onDragOver={this.dragOver.bind(this)}>
					<Row style={{ backgroundColor: 'white' }}>
						{this.props.articulo.imgSrc.map((c, i) => {
							return (
								<Col className='imagenArticuloContainer' md={3} data-id={c.orden} draggable='true' onDragEnd={this.dragEnd.bind(this)} onDragStart={this.dragStart.bind(this)} >
									<div>
										<Checkbox className='check' onChange={(e) => this.props.handleCheckboxChange({ i }, e)} value={c.selected} checked={c.selected} />
										<div>
											<PopupState variant="popover" popupId="demo-popup-menu">
												{popupState => (
													<React.Fragment>
														<IconButton
															className='iconMenu'
															{...bindTrigger(popupState)}
														>
															<MoreVertIcon />
														</IconButton>
														<Menu {...bindMenu(popupState)}>
															<MenuItem onClick={()=> {this.props.handleEliminarImagenArticulo(i)}}>Eliminar</MenuItem>
														</Menu>
													</React.Fragment>
												)}
											</PopupState>
										</div>
										<div className='imageContainer'>
											{c !== undefined  ?
												<img onClick={() => { this.props.handleOnOpenCropperModal(c) }} src={c.pathImagen != undefined ? c.pathImagen : `data:image/ief;base64,${c.imagen}`} className='imagenArticulo' />
												:
												<div>
													<CircularProgress />
												</div>
											}
										</div>
									</div>
								</Col>)
						})
						}
					</Row>
				</Paper>    
                    
                {/* CROPPER PARA IMAGENES ARTÍCULO */}
				{this.props.openModalImagen &&
					<CropperModal
						ratio={2 / 3}
						src={this.props.imagenOriginal}
						handleOnCloseCropperModal={this.props.handleOnCloseCropperModal}
						handleOnSaveImagenCortada={this.props.handleOnSaveImagenCortada}
						open={this.props.openModalImagen}
						modalArticulo={true}
					/>
				}

            </div>
        )
    }
}


ArticuloGenericoNuevo.propTypes = {
    articulo: PropTypes.object.isRequired, 
    rubros: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    handleOnNombre: PropTypes.func.isRequired,
    handleOnPrecio: PropTypes.func.isRequired,
    handleOnCodigoInterno: PropTypes.func.isRequired,
    handleOnSubrubro: PropTypes.func.isRequired,
    handleOnStock: PropTypes.func.isRequired,
    handleOnDropFile: PropTypes.func.isRequired,
    handleCheckboxChange: PropTypes.func.isRequired,
    handleEliminarImagenArticulo: PropTypes.func.isRequired,
    handleOnOpenCropperModal: PropTypes.func.isRequired,
    handleOnCloseCropperModal: PropTypes.func.isRequired,
    handleOnChangeOrderArticuloImagenes: PropTypes.func.isRequired,
    handleOnDescripcion: PropTypes.func.isRequired,
    handleOnSave: PropTypes.func.isRequired,
    clearState :PropTypes.bool.isRequired,
    valid :PropTypes.bool.isRequired,
    errorDescription :PropTypes.object.isRequired,
    onChangeFalseEditorState :PropTypes.func.isRequired,
    openModalImagen :PropTypes.bool.isRequired,
    imagenOriginal :PropTypes.object.isRequired,
    handleOnSaveImagenCortada:PropTypes.func.isRequired,
    handleDelete: PropTypes.func.isRequired,
    handleOnCampoEtiqueta: PropTypes.func.isRequired,
    campoEtiqueta: PropTypes.string.isRequired,
    handleOnAddEtiqueta: PropTypes.func.isRequired,

    esEdicion: PropTypes.bool.isRequired,
}

ArticuloGenericoNuevo.defaultProps = {
    handleDelete: f => f,
    handleOnCampoEtiqueta: f => f,
    handleOnAddEtiqueta: f => f,
}

export default withStyles(styles)(ArticuloGenericoNuevo)